import React, { Component } from 'react'
import gql from 'graphql-tag'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import FormGroup from '@material-ui/core/FormGroup'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import CustomTabs from '../../Modules/CustomTabs'
import { ApolloConsumer } from 'react-apollo'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import Select from 'react-select'
import getLoginId from '../../../utils/getLoginId'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
import FormHelperText from '@material-ui/core/FormHelperText'
import Countries from '../../Modules/Countries'
import States from '../../Modules/States'

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing.unit * 2
  }
})

const GET_PARTNER = gql`
  query partnerDetail($loginId: Int) {
    partnerDetail(loginId: $loginId) {
      id
      billingMode {
        id
        billingMode
      }
      businessName
      contactPerson
      address
      city
      SalesPerson {
        id
        name
      }
      state {
        zone_id
      }
      country {
        country_id
      }
      login {
        username
      }
      email
      contactNumber
      pincode
      panNumber
      partnerType
      solution
    }
  }
`
const UPDATE_PARTNER = gql`
  mutation updatePartnerDetail(
    $businessName: String!
    $email: String!
    $contactPerson: String!
    $contactNumber: String!
    $address: String!
    $city: String!
    $state: Int!
    $country: Int!
    $pincode: Int!
    $panNumber: String!
    $login_id: Int!
    $status: Int!
    $id: Int!
    $billingMode: Int!
    $partnerType: String!
    $salesPersonId: Int!
    $solution: String!
  ) {
    updatePartnerDetail(
      businessName: $businessName
      email: $email
      contactPerson: $contactPerson
      contactNumber: $contactNumber
      address: $address
      city: $city
      state_id: $state
      country_id: $country
      pincode: $pincode
      panNumber: $panNumber
      login_id: $login_id
      status: $status
      id: $id
      partnerType: $partnerType
      billingMode: $billingMode
      salesPersonId: $salesPersonId
      solution: $solution
    )
  }
`

// Business name validation
const GET_BUSINESSNAME = gql`
  query checkBusinessName($id: Int, $businessname: String!) {
    checkBusinessName(id: $id, businessName: $businessname)
  }
`
// username validation
const GET_USERNAME = gql`
  query checkUsername($id: Int, $username: String!) {
    checkUsername(id: $id, username: $username)
  }
`
// Business name validation
const GET_CONTACTNO = gql`
  query checkPartnerContactNumber($id: Int, $phoneno: String!) {
    checkPartnerContactNumber(id: $id, contactNumber: $phoneno)
  }
`
// Business email validation
const GET_EMAIL = gql`
  query checkPartnerEmail($id: Int, $email: String!) {
    checkPartnerEmail(id: $id, email: $email)
  }
`
// Business pan validation
const GET_PAN_NUMBER = gql`
  query checkPartnerPanNumber($id: Int, $pan: String!) {
    checkPartnerPanNumber(id: $id, panNumber: $pan)
  }
`
const GET_ALL_SALESPERSON = gql`
  query getAllSalesPerson($partnerLoginId: Int) {
    getAllSalesPerson(partnerLoginId: $partnerLoginId) {
      id
      name
    }
  }
`
const BILLING_MODES = [
  {
    value: 1,
    label: 'PREPAID'
  },
  {
    value: 2,
    label: 'POSTPAID'
  }
]

class PartnerEdit extends Component {
  constructor(props) {
    super(props)
    this.loginId = this.props.match.params.loginId

    this.state = {
      clientId: '',
      name: '',
      username: '',
      person: '',
      password: '123345',
      email: '',
      phoneno: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      pincode: '',
      pan: '',
      gst: '',
      plan: '',
      timezone: '',
      isEmailValid: true,
      isPhonenoValid: true,
      isAddressValid: true,
      isCityValid: true,
      isPinValid: true,
      isPanValid: true,
      isGSTValid: true,
      isUsernameValid: true,
      isNameValid: true,
      isContactpValid: true,
      isPasswordValid: true,
      isUsernameUnique: true,
      response: false,
      modelName: [],
      licenseId: [],
      billingFrequencies: '',
      billingFrequency: '',
      freePeriod: '',
      bufferPeriod: '',
      totalPeriod: '',
      discount: '',
      loginId: '',
      existingModels: [],
      existingLicenses: [],
      lflag: 1,
      mflag: 1,
      partnerType: '',
      billingMode: '',
      allSalesPerson: [],
      salesPerson: '',
      panNoRes: '',
      phoneNoRes: '',
      nameRes: '',
      emailRes: '',
      userNameRes: '',
      isCancelConfDialogOpen: false,
      isSaveConfDialogOpen: false,
      isStateChanged: false,
      solution: ''
    }
  }

  getClients = async () => {
    const { data } = await this.props.client.query({
      query: GET_PARTNER,
      variables: {
        loginId: parseInt(this.loginId, 10)
      },
      fetchPolicy: 'network-only'
    })
    // console.log('details', data)
    this.setDetails(data.partnerDetail)
  }

  getAllSalesPersonDetails = async () => {
    const fetchSalesPersonData = await this.props.client.query({
      query: GET_ALL_SALESPERSON,
      variables: {
        partnerLoginId: getLoginId()
      }
    })
    const {
      data: { getAllSalesPerson }
    } = fetchSalesPersonData
    const salesPersonsDetails = getAllSalesPerson.map(salesPerson => ({
      value: salesPerson.id,
      label: salesPerson.name
    }))
    // console.log('Edit customer getAllsataperson :', salesPersonsDetails)
    this.setState({ allSalesPerson: salesPersonsDetails })
  }

  componentDidMount() {
    this.getClients()
    this.getAllSalesPersonDetails()
  }

  setDetails = partnerDetail => {
    console.log('details', partnerDetail, partnerDetail.salesPerson)
    this.setState({
      clientId: partnerDetail.id,
      name: partnerDetail.businessName,
      username: partnerDetail.login.username,
      person: partnerDetail.contactPerson,
      email: partnerDetail.email,
      phoneno: partnerDetail.contactNumber,
      address1: partnerDetail.address,
      city: partnerDetail.city,
      state: partnerDetail.state.zone_id,
      country: partnerDetail.country.country_id,
      pincode: partnerDetail.pincode,
      pan: partnerDetail.panNumber,
      loginId: partnerDetail.login.loginId,
      partnerType: partnerDetail.partnerType,
      billingMode: partnerDetail.billingMode.id,
      salesPerson:
        partnerDetail.SalesPerson.name && partnerDetail.SalesPerson.id,
      solution: partnerDetail.solution
    })
  }

  handleInputChange = name => e =>
    this.setState(
      { [name]: e.target.value }
      // console.log('name=', [name], e.target.value)
    )

  handleStateRender() {
    if (this.state.country) {
      return (
        <Grid item xs={6}>
          <FormGroup className="form-input">
            <States
              countryId={this.state.country}
              zoneId={this.state.state}
              handleStateChange={this.handleStateChange}
            />
          </FormGroup>
        </Grid>
      )
    }
  }

  handleBillingModeChange = billingMode => {
    this.setState({
      isStateChanged: true
    })
    if(billingMode){
      this.setState({ billingMode: billingMode.value })
    }else {
    this.setState({ billingMode: '' })
    }
  }

  handleSalesPersonChange = salesPerson => {
    console.log('salesp', salesPerson)
    this.setState({
      isStateChanged: true
    })
    if(salesPerson){
    this.setState({ salesPerson: salesPerson.value })
  }else {
    this.setState({ salesPerson: '' })
  }
}

  handleCountryChange = country => {
    this.setState({
      isStateChanged: true
    })
    if (!country) {
      this.setState({ state: null, country: null })
      // this.props.openSnackbar('Please select a Country')

    } else {
      this.setState({ state: null, country: country.value })
    }
  }

  handleStateChange = state => {
    this.setState({
      isStateChanged: true
    })
    if(state){
      this.setState({ state: state.value })
    }else{
      // this.props.openSnackbar('Please select a state')
      this.setState({ state: null })

    }
    
  }


  handlePlanChange = plan => {
    this.setState({
      isStateChanged: true
    })
    if (!plan) {
      this.setState({ plan: '' })
    } else {
      this.setState({ plan: plan.value })
    }
  }
  handleChangeLicense = event => {
    this.setState({ licenseId: event.target.value })
    // console.log(this.state.licenseId)
  }
  handleChangeModels = event => {
    this.setState({ modelName: event.target.value })
  }
  handleTimezoneChange = timezone => {
    if (!timezone) {
      this.setState({ timezone: '' })
    } else {
      this.setState({ timezone: timezone.value })
    }
    console.log('p', timezone)
  }
  handleChangeFreePeriod = name => value => {
    const total =
      parseInt(value.target.value, 10) + parseInt(this.state.bufferPeriod, 10)
    this.setState({
      [name]: value.target.value,
      totalPeriod: total
    })
  }
  handleChangeBufferPeriod = name => value => {
    const total =
      parseInt(this.state.freePeriod, 10) + parseInt(value.target.value, 10)
    this.setState({
      [name]: value.target.value,
      totalPeriod: total
    })
  }

  handleChangeDiscount = name => value => {
    this.setState({ [name]: value.target.value })
  }
  handleSelectChange = name => value => {
    this.setState({ [name]: value })
  }

  checkBusinessNameValidity = async event => {
    console.log('gggg')
    const regex = new RegExp(
      /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,32}$/
    )
    const { data } = await this.props.client.query({
      query: GET_BUSINESSNAME,
      variables: {
        id: parseInt(this.state.clientId, 10),
        businessname: this.state.name
      }
    })
    console.log('hh', data.checkBusinessName)
    this.setState({
      isNameValid:
        regex.test(this.state.name) &&
        this.state.name !== '' &&
        data.checkBusinessName === 'AVAILABLE'
    })
    if (regex.test(this.state.name) === false) {
      this.setState({ nameRes: 'Invalid Business Name' })
    } else if (data.checkBusinessName !== 'AVAILABLE') {
      this.setState({ nameRes: 'Business name already exist' })
    }
  }

  checkUsernameValidity = client => async event => {
    // checkUsernameValidity = () => {
    const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,30}$/)
    const { data } = await client.query({
      query: GET_USERNAME,
      variables: {
        id: parseInt(this.state.login_id, 10),
        username: this.state.username
      }
    })
    this.setState({
      isUsernameUnique: data.checkUsername === 'AVAILABLE',
      isUsernameValid:
        regex.test(this.state.username) &&
        this.state.username !== '' &&
        data.checkUsername === 'AVAILABLE'
    })
  }

  checkContactpValidity = () => {
    const regex = new RegExp(/^[a-zA-Z\s]{5,32}$/)
    this.setState({
      isContactpValid: regex.test(this.state.person) && this.state.person !== ''
    })
  }

  checkPasswordValidity = () => {
    // const regex = new RegExp(/^((?!.*[\s])(?=.*[A-Z])(?=.*\d).{5,10})/)
    const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,20}$/)
    console.log('pass=', regex.test(this.state.password))
    this.setState({
      isPasswordValid:
        this.state.password !== '' && regex.test(this.state.password)
    })
  }

  checkPhonenoValidity = async event => {
    console.log('pp')
    const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{9,12}$/)
    const { data } = await this.props.client.query({
      query: GET_CONTACTNO,
      variables: {
        id: parseInt(this.state.clientId, 10),
        phoneno: this.state.phoneno
      }
    })
    console.log('phoneno', data, this.state.phoneno)
    this.setState({
      isPhonenoValid:
        regex.test(this.state.phoneno) &&
        this.state.phoneno !== '' &&
        data.checkPartnerContactNumber === 'AVAILABLE'
    })
    if (regex.test(this.state.phoneno) === false) {
      this.setState({ phoneNoRes: 'Invalid phone number' })
    } else if (data.checkPartnerContactNumber !== 'AVAILABLE') {
      this.setState({ phoneNoRes: 'Phone number already exist' })
    }
  }

  checkEmailValidity = async event => {
    const regex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    const { data } = await this.props.client.query({
      query: GET_EMAIL,
      variables: {
        id: parseInt(this.state.clientId, 10),
        email: this.state.email
      }
    })

    console.log('email', data, this.state.email)
    this.setState({
      isEmailValid:
        regex.test(this.state.email) &&
        this.state.email !== '' &&
        data.checkPartnerEmail === 'AVAILABLE'
    })
    if (regex.test(this.state.email) === false) {
      this.setState({ emailRes: 'Invalid email id' })
    } else if (data.checkPartnerEmail !== 'AVAILABLE') {
      this.setState({ emailRes: 'Email already exist' })
    }
  }

  checkAddressValidity = () => {
    // const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)
    const regex= new RegExp(/^(.{5,200})$/)
    const regex2 = new RegExp(/^[^\s]+(\s+[^\s]+)*$/)
    this.setState({
      isAddressValid:
        // regex.test(this.state.address1) && this.state.address1 !== ''
        regex.test(this.state.address1) && regex2.test(this.state.address1)
    })
  }
  checkCityValidity = () => {
    const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/)

    this.setState({
      isCityValid:
        regex.test(this.state.city) &&
        this.state.city !== '' &&
        parseInt(this.state.city.length, 10) < 32
    })
    console.log('city', this.state.city.length, this.state.isCityValid)
  }

  checkPinValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]{5}$/)
    this.setState({
      isPinValid: regex.test(this.state.pincode) && this.state.pincode !== ''
    })
  }

  checkPanValidity = async event => {
    const regex = new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/)
    this.setState({ panNoRes: '' })
    const { data } = await this.props.client.query({
      query: GET_PAN_NUMBER,
      variables: { id: parseInt(this.state.clientId, 10), pan: this.state.pan }
    })

    this.setState({
      isPanValid:
        regex.test(this.state.pan) &&
        this.state.pan !== '' &&
        data.checkPartnerPanNumber === 'AVAILABLE'
    })
    if (regex.test(this.state.pan) === false) {
      this.setState({ panNoRes: 'Invalid pan number' })
    } else if (data.checkPartnerPanNumber !== 'AVAILABLE') {
      this.setState({ panNoRes: 'Pan number already exist' })
    }
  }
  checkCountryValidity = () => {
    this.setState({
      isCountryValid: this.state.country !== ''
    })
  }

  checkStateValidity = () => {
    this.setState({
      isStateValid: this.state.state !== ''
    })
  }

  checkCltTypeValidity = () => {
    this.setState({
      isCltTypeValid: this.state.clttype !== ''
    })
  }

  onCountryFetched = async getStatesId => this.setState({ getStatesId })

  handleSaveClick = e => {
    this.setState({ isSaveConfDialogOpen: true })
  }

  // submitForm = addClient => e => {
  submitForm = client => async e => {
    console.log("this.state.country",this.state.country)
    e.preventDefault()
    const { data, errors } = await this.props.client.mutate({
      mutation: UPDATE_PARTNER,
      variables: {
        id: parseInt(this.state.clientId, 10),
        businessName: this.state.name,
        login_id: parseInt(this.loginId, 10),
        email: this.state.email,
        contactPerson: this.state.person,
        contactNumber: this.state.phoneno,
        address: this.state.address1 + ' ' + this.state.address2,
        city: this.state.city,
        state: parseInt(this.state.state, 10),
        country: parseInt(this.state.country, 10),
        pincode: parseInt(this.state.pincode, 10),
        panNumber: this.state.pan,
        status: 1,
        // loginId: parseInt(this.state.loginId, 10),
        partnerType: this.state.partnerType,
        billingMode: parseInt(this.state.billingMode, 10),
        salesPersonId: parseInt(this.state.salesPerson, 10),
        solution: this.state.solution
      },
      errorPolicy: 'all',
      refetchQueries: ['allPartnerDetails', 'partnerDetail']
    })
    // console.log('+++++++++++', data)

  if (data && data.updatePartnerDetail) {
      this.props.openSnackbar('Updated Successfully')
      this.props.history.push({
        pathname: '/home/partner/view/' + this.loginId
      })
    }
    
    else {
      this.props.openSnackbar(errors[0].message)
      this.setState({ isSaveConfDialogOpen: false })
    }
  }
  handleCancelClick = e => {
    console.log('hhh', this.state.isStateChanged)
    if (this.state.isStateChanged) {
      this.setState({ isCancelConfDialogOpen: true })
    } else {
      this.cancelForm()
    }
  }
  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSaveConfDialogOpen: false })
  }

  cancelForm = e => {
    this.setState({
      clientId: '',
      name: '',
      username: '',
      person: '',
      password: '',
      email: '',
      phoneno: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      pincode: '',
      pan: '',
      gst: '',
      plan: '',
      timezone: ''
    })
    this.props.history.goBack()
  }

  render() {
    const {
      name,
      username,
      person,
      password,
      email,
      phoneno,
      address1,
      address2,
      city,
      state,
      country,
      pincode,
      pan,
      gst,
      billingMode,
      allSalesPerson,
      salesPerson
    } = this.state

    const { classes } = this.props
    

    return (
      <div className={classes.root}>
        <ConfirmationalDialog
          isDialogOpen={this.state.isSaveConfDialogOpen}
          dialogMessage={
            "Are you sure you want to Save this customer's details?"
          }
          negativeResponseHandler={this.handleSaveNegativeResponse}
          positiveResponseHandler={this.submitForm(this.props.client)}
        />
        <ConfirmationalDialog
          isDialogOpen={this.state.isCancelConfDialogOpen}
          dialogMessage={
            'Are you sure you want to Cancel new customer creation?'
          }
          negativeResponseHandler={this.handleCancelNegativeResponse}
          positiveResponseHandler={this.cancelForm}
        />
        <Grid container spacing={16}>
          <Grid item xs={12} justify="flex-start">
            {/* TODO: Back button functionality */}
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              // onClick={() => this.viewSubscription(this.backUrl)}
              onClick={() => this.props.history.goBack()}
              // href={'/home/customers/view/' + this.loginId}
            >
              <ArrowBackIcon className={classes.iconSmall} />
            </Button>{' '}
          </Grid>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Edit Partner"
                subheader="All fields marked with (*) are mandatory"
                subheaderTypographyProps={{
                  className: classes.italicizedText
                }}
              />
              <CardContent>
                <Grid container spacing={16}>
                  <Grid item xs={12} md={6}>
                    <FormGroup className="form-input">
                      <TextField
                        // autoComplete="username"
                        name="name"
                        value={this.state.name}
                        type="text"
                        label="Business Name"
                        required
                        onChange={this.handleInputChange('name')}
                        error={!this.state.isNameValid}
                        onBlur={this.checkBusinessNameValidity}
                      />
                      <FormHelperText
                        id="name-error-text"
                        className="Error_msg"
                      >
                        {!this.state.isNameValid ? this.state.nameRes : ''}
                      </FormHelperText>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={6}>
                    <FormGroup className="form-input">
                      <TextField
                        // autoComplete="username"
                        name="username"
                        value={username}
                        type="text"
                        onChange={this.handleInputChange('username')}
                        label="Username"
                        required
                        disabled
                        // error={!isUsernameValid}
                        // onBlur={this.checkUsernameValidity}
                        // label={!isUsernameValid ? 'Invalid Username' : ''}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={6}>
                    <FormGroup className="form-input">
                      <TextField
                        // autoComplete="username"
                        name="person"
                        value={person}
                        type="text"
                        label="Contact Person"
                        required
                        onChange={this.handleInputChange('person')}
                        error={!this.state.isContactpValid}
                        onBlur={this.checkContactpValidity}
                      />
                      <FormHelperText
                        id="name-error-text"
                        className="Error_msg"
                      >
                        {!this.state.isContactpValid
                          ? 'Invalid Contact Person Name'
                          : ''}
                      </FormHelperText>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={6}>
                    <FormGroup className="form-input">
                      <TextField
                        // autoComplete="username"
                        name="password"
                        value={password}
                        type="password"
                        onChange={this.handleInputChange('password')}
                        label="Password"
                        error={!this.state.isPasswordValid}
                        disabled
                      />
                    </FormGroup>
                  </Grid>

                  <Grid item xs={6}>
                    <FormGroup className="form-input">
                      <TextField
                        // autoComplete="username"
                        name="email"
                        value={this.state.email}
                        type="text"
                        // onChange={this.handleInputChange}
                        label="Email"
                        required
                        onChange={this.handleInputChange('email')}
                        // placeholder="Email"
                        error={!this.state.isEmailValid}
                        onBlur={this.checkEmailValidity}
                      />
                      <FormHelperText
                        id="name-error-text"
                        className="Error_msg"
                      >
                        {!this.state.isEmailValid ? this.state.emailRes : ''}
                      </FormHelperText>
                    </FormGroup>
                  </Grid>

                  <Grid item xs={6}>
                    <FormGroup className="form-input">
                      <TextField
                        // autoComplete="username"
                        name="phoneno"
                        value={this.state.phoneno}
                        type="text"
                        label="Phone Number"
                        required
                        onChange={this.handleInputChange('phoneno')}
                        error={!this.state.isPhonenoValid}
                        onBlur={this.checkPhonenoValidity}
                      />
                      <FormHelperText
                        id="name-error-text"
                        className="Error_msg"
                      >
                        {!this.state.isPhonenoValid
                          ? this.state.phoneNoRes
                          : ''}
                      </FormHelperText>
                    </FormGroup>
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <FormGroup className="form-input">
                      <Select
                        options={BILLING_MODES}
                        value={billingMode}
                        name="billingMode"
                        onChange={this.handleBillingModeChange}
                        placeholder="Select Billing Mode*"
                      />
                    </FormGroup>
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <FormGroup className="form-input">
                      <Select
                        options={allSalesPerson}
                        value={this.state.salesPerson}
                        onChange={this.handleSalesPersonChange}
                        placeholder="Select Sales Person*"
                      />
                    </FormGroup>
                  </Grid>

                  {/* <Grid item xs={12}>
                    <CustomTabs
                      address1={address1}
                      address2={address2}
                      city={city}
                      state={state}
                      country={country}
                      pincode={pincode}
                      pan={pan}
                      gst={gst}
                      handleInputChange={this.handleInputChange}
                      handleCountryChange={this.handleCountryChange}
                      handleStateChange={this.handleStateChange}
                      isAddressValid={this.state.isAddressValid}
                      isCityValid={this.state.isCityValid}
                      isPinValid={this.state.isPinValid}
                      isPanValid={this.state.isPanValid}
                      isGSTValid={this.state.isGSTValid}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6}>
                    <FormGroup className="form-input">
                      <TextField
                        id="address1"
                        name="address1"
                        className="textfield"
                        margin="dense"
                        label="Address"
                        type="Multi-line"
                        value={this.state.address1}
                        required
                        onChange={this.handleInputChange('address1')}
                        error={!this.state.isAddressValid}
                        onBlur={this.checkAddressValidity}
                      />
                      <FormHelperText
                        id="name-error-text"
                        className="Error_msg"
                      >
                        {!this.state.isAddressValid ? 'Invalid Address' : ''}
                      </FormHelperText>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormGroup className="form-input">
                      <TextField
                        id="city"
                        name="city"
                        className="textfield"
                        margin="dense"
                        label="City"
                        // type="Multi-line"
                        value={this.state.city}
                        required
                        onChange={this.handleInputChange('city')}
                        error={!this.state.isCityValid}
                        onBlur={this.checkCityValidity}
                      />
                      <FormHelperText
                        id="name-error-text"
                        className="Error_msg"
                      >
                        {!this.state.isCityValid ? 'Invalid City' : ''}
                      </FormHelperText>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormGroup className="form-input">
                      <Countries
                        countryId={this.state.country}
                        handleCountryChange={this.handleCountryChange}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {this.handleStateRender()}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormGroup className="form-input">
                      <TextField
                        id="pincode"
                        name="pincode"
                        className="textfield"
                        margin="dense"
                        label="Pin Code"
                        // type="Multi-line"
                        value={this.state.pincode}
                        required
                        onChange={this.handleInputChange('pincode')}
                        error={!this.state.isPinValid}
                        onBlur={this.checkPinValidity}
                      />
                      <FormHelperText
                        id="name-error-text"
                        className="Error_msg"
                      >
                        {!this.state.isPinValid ? 'Invalid Pin Number' : ''}
                      </FormHelperText>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormGroup className="form-input">
                      <TextField
                        id="pan"
                        name="pan"
                        className="textfield"
                        margin="dense"
                        label="PAN No"
                        // type="Multi-line"
                        value={this.state.pan}
                        required
                        onChange={this.handleInputChange('pan')}
                        error={!this.state.isPanValid}
                        onBlur={this.checkPanValidity}
                      />
                      <FormHelperText
                        id="name-error-text"
                        className="Error_msg"
                      >
                        {this.state.isPanValid ? '' : this.state.panNoRes}
                      </FormHelperText>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6} />
                </Grid>
              </CardContent>
              <CardActions>
                <Button
                  color="secondary"
                  variant="contained"
                  // className={this.classes.button}
                  // onClick={this.submitForm}
                  onClick={this.handleSaveClick}
                  disabled={
                    this.state.country == null || this.state.state == null|| this.state.salesPerson == "" || this.state.billingMode == "" || !this.state.isPinValid
                    || !this.state.isPanValid || this.state.name == "" || this.state.person == "" || this.state.phoneno == "" ||
                    this.state.address1 == "" || this.state.city == "" || this.state.email == "" || !this.state.isAddressValid || !this.state.isPhonenoValid ||
                    !this.state.isCityValid || !this.state.isEmailValid || !this.state.isContactpValid 
                  }
                >
                  Save{' '}
                </Button>

                <Button
                  color="secondary"
                  // className={this.classes.button}
                  onClick={this.handleCancelClick}
                >
                  Cancel{' '}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const withApolloClient = Component => props => (
  <ApolloConsumer>
    {client => <Component client={client} {...props} />}
  </ApolloConsumer>
)

PartnerEdit.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(
  withApolloClient(withSharedSnackbar(PartnerEdit))
)



// WEBPACK FOOTER //
// ./src/components/Pages/Partner/PartnerEdit.jsx